import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api } from "@/api";

export const DropBanner = () => {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    if (sessionStorage.getItem("jfly_banner_dismissed")) return;
    api
      .get("/settings/drop-banner")
      .then((r) => {
        if (r.data?.enabled) setBanner(r.data);
      })
      .catch(() => {});
  }, []);

  if (!banner) return null;

  const dismiss = () => {
    sessionStorage.setItem("jfly_banner_dismissed", "1");
    setBanner(null);
  };

  const go = () => document.getElementById("shop")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div data-testid="drop-banner" className="fixed inset-x-0 top-16 z-40 border-b-2 border-[#F5F2EB] bg-[#FF3B1F]">
      <div className="relative flex items-center justify-center gap-3 px-6 py-2 text-[10px] font-mono font-semibold uppercase tracking-[0.2em] text-white">
        <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-white" />
        <button onClick={go} data-testid="drop-banner-cta" className="hover:underline">
          {banner.text || "New drop is live — as seen on TikTok @jitclips2"}
        </button>
        <button onClick={dismiss} data-testid="drop-banner-close" className="absolute right-4 text-white/80 transition-colors hover:text-white">
          <X size={14} />
        </button>
      </div>
    </div>
  );
};
